import api from './api'

const itemMappingService = {
  async getAll(customerId) {
    const params = customerId ? { customerId } : {}
    const response = await api.get('/item-mappings', { params })
    return response.data
  },

  async getById(id) {
    const safeId = encodeURIComponent(id)
    const response = await api.get(`/item-mappings/${safeId}`)
    return response.data
  },

  async create(mappingData) {
    const response = await api.post('/item-mappings', mappingData)
    return response.data
  },

  async update(id, mappingData) {
    const safeId = encodeURIComponent(id)
    const response = await api.put(`/item-mappings/${safeId}`, mappingData)
    return response.data
  },

  async delete(id) {
    // Use query-param based delete so we don't rely on path params that may contain
    // encoded slashes (%2F) which some proxies block.
    const response = await api.delete('/item-mappings', {
      params: { mappingId: id }
    })
    return response.data
  },

  async bulkImport(customerId, mappings) {
    const response = await api.post('/item-mappings/bulk-import', {
      customerId,
      mappings
    })
    return response.data
  },

  async bulkImportFile(customerId, file) {
    const formData = new FormData()
    formData.append('customerId', customerId)
    formData.append('file', file)
    const response = await api.post('/item-mappings/bulk-import', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    return response.data
  },

  async bulkDelete(mappingIds) {
    const response = await api.post('/item-mappings/bulk-delete', {
      mappingIds
    })
    return response.data
  },

  async clearCustomer(customerId) {
    const response = await api.delete('/item-mappings/clear', {
      params: { customerId }
    })
    return response.data
  }
}

export default itemMappingService
